import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../config';

function PublicPortfolio() {
  const [portfolio, setPortfolio] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPortfolio();
  }, []);

  const fetchPortfolio = async () => {
    try {
      // Fetch portfolio without auth header (public endpoint)
      const response = await axios.get(`${API_URL}/portfolio`, {
        headers: { Authorization: '' }
      });
      setPortfolio(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      setLoading(false);
    }
  };

  return (
    <div className="public-portfolio-page">
      <nav className="public-nav">
        <img src="/images/logo.png" alt="Holland House Salon" className="salon-logo"/>
        <h1>Our Work</h1>
        <div className="public-nav-links">
          <Link to="/book" className="portfolio-link">Book Appointment</Link>
        </div>
      </nav>

      <div className="portfolio-public-container">
        <div className="portfolio-intro">
          <h2>Portfolio</h2>
          <p>Explore our recent work and get inspired for your next visit</p>
        </div>

        {loading ? (
          <div className="loading">Loading portfolio...</div>
        ) : portfolio.length > 0 ? (
          <div className="portfolio-public-gallery">
            {portfolio.map(item => (
              <div key={item.id} className="portfolio-public-item">
                <div className="portfolio-public-image">
                  <img src={item.image_url} alt={item.title} />
                </div>
                <div className="portfolio-public-info">
                  <h3>{item.title}</h3>
                  {item.description && <p>{item.description}</p>}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-portfolio">
            <p>No portfolio items available yet. Check back soon!</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicPortfolio;
